import { ControlInterface } from 'edocatbase/Form';
import { default as EdocatCheckBox } from "../../../CheckBox";

export default class CheckBox extends window.React.PureComponent<ControlInterface> {
	onChange = () => {
		const { name, onChange, value } = this.props;
		onChange([name], !value, true);
	};

	render() {
		const { value, label, disabled, name, readOnly, className } = this.props;

		return readOnly || disabled ? (
			<div className={`form-row row-${name} ${readOnly ? 'simple-row' : 'read-only-row'}`}>
				<label>{label}</label>
				<div>{window.Alfresco.messages.global[`label.${String(value) === "true" ? 'yes' : 'no'}`]}</div>
			</div>
		) : (
			<div className={`form-row row-${name} checkbox-outer-row`}>
				<EdocatCheckBox
					id={name}
					checked={value}
					disabled={disabled}
					label={label}
					name={name}
					onChange={this.onChange}
				/>
			</div>
		);
	}
}
